// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-9022a60c]{min-width:166px;width:-webkit-max-content;width:-moz-max-content;width:max-content;height:60px;display:flex;align-items:center;justify-content:center}.button svg[data-v-9022a60c]{margin-right:6px}", ""]);
// Exports
module.exports = exports;
